import { useKeycloak } from '@react-keycloak/web';
import React, { useEffect, useState } from 'react';
import { RouterProvider } from 'react-router';

import { createAppRouter } from './AppRouter';
import { useUserData } from './redux/selectors';

const RouterGuard = (): React.JSX.Element | null => {
  const { keycloak: kc, initialized } = useKeycloak();
  const user = useUserData();
  const [appRouter, setAppRouter] = useState<ReturnType<typeof createAppRouter> | null>(null);

  useEffect(() => {
    if (!initialized) return;

    // not authenticated -> create router and allow public pages
    if (!kc.authenticated) {
      setAppRouter(createAppRouter());
      return;
    }

    // already have user -> create router
    if (Object.keys(user).length > 0) {
      setAppRouter(createAppRouter());
    }
  }, [initialized, kc.authenticated, user]);

  if (!appRouter) return null;

  return <RouterProvider router={appRouter} />;
};

export default RouterGuard;
